import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import moment from "moment";
import { bookingService, userService } from "../../api/apiService";
import { lanoService } from "../../api/lanoService";
import { customStyles } from "./../../helpers/StyleUtils";
import "../../App.css";
import edit from './../../images/edit.svg';

const DeletedOrdersList = ({ events }) => {
  let userEmail = localStorage.getItem("userEmail");
  const [filterPreferences, setFilterPreferences] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCreatedAt, setSelectedCreatedAt] = useState(null);
  const [selectedstartDate, setSelectedstartDate] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [selectedSet, setSelectedSet] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedPreferenceIndex, setSelectedPreferenceIndex] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
   
    const fetchPreferences = async () => {
      if (!userEmail) return;

      try {
        const response = await userService.getUserPreferences(userEmail);
        if (response.data && response.data.filterPreferences) {
          setFilterPreferences(response.data.filterPreferences || []);
        } else {
          console.log("No filter preferences found.");
        }
      } catch (error) {
        console.error("Error fetching user preferences:", error);
      }
    };

    fetchPreferences();
  }, [userEmail]);

  const applyFilterPreference = (index) => {
    if (index < 0 || index >= filterPreferences.length) {
      console.log("Invalid filter preference index.");
      return;
    }

    const preference = filterPreferences[index];
    setSearchTerm(preference.searchTerm);
    setSelectedCreatedAt(preference.selectedCreatedAt);
    setSelectedClient(preference.selectedClient);
    setSelectedPosition(preference.selectedPosition);
    setSelectedSet(preference.selectedSet);
    setSelectedLocation(preference.selectedLocation);
  };

  const preferenceOptions = filterPreferences.map((_, index) => ({
    value: index,
    label: `Preference ${index + 1}`,
  }));

  const handlePreferenceChange = (selectedOption) => {
    setSelectedPreferenceIndex(selectedOption ? selectedOption.value : null);
    if (selectedOption) {
      applyFilterPreference(selectedOption.value);
    } else {
      // Clear all filter preferences here
      setSearchTerm("");
      setSelectedCreatedAt(null);
      setSelectedClient(null);
      setSelectedPosition(null);
      setSelectedSet(null);
      setSelectedLocation(null);
    }
  };

  const handleCheckboxChange = (index) => {
    setSelectedOrders((prevSelected) => ({
      ...prevSelected,
      [index]: !prevSelected[index],
    }));
  };

  const saveOrUpdateFilterPreference = async () => {
    const newPreference = {
      searchTerm,
      selectedCreatedAt,
      selectedClient,
      selectedPosition,
      selectedSet,
      selectedLocation,
    };

    if (selectedPreferenceIndex !== null) {
      // Update an existing preference
      filterPreferences[selectedPreferenceIndex] = newPreference;
    } else {
      // Save a new preference if there's room
      if (filterPreferences.length < 3) {
        filterPreferences.push(newPreference);
      } else {
        alert("You can only save up to 3 filter preferences.");
        return;
      }
    }

    try {
      // Update the user preferences in the API
      await userService.savePreferences(userEmail, { filterPreferences });
      setFilterPreferences([...filterPreferences]); // Update local state
      alert("Filter preferences updated successfully.");
    } catch (error) {
      console.error("Error updating preferences:", error);
      alert("Failed to update filter preferences.");
    }
  };

  const markTheOrder = async () => {
    const selectedOrderIds = Object.keys(selectedOrders).filter(
      (id) => selectedOrders[id]
    );

    if (selectedOrderIds.length === 0) {
      console.log("No orders selected.");
      return;
    }

    try {
      // Process all selected orders with Promise.all for parallel processing
      await Promise.all(
        selectedOrderIds.map(async (orderId) => {
          const bookingData = {
            proposedBy: userEmail
          };
          return bookingService.updateBooking(orderId, bookingData);
        })
      );

      alert("Booking marked successfully.");
      window.location.reload();
    } catch (error) {
      console.error("Error marking selected orders:", error);
      alert("Failed to mark selected orders. Please try again.");
    }
  };

  const RestoreTheOrder = async () => {
    const selectedOrderIds = Object.keys(selectedOrders).filter(
      (id) => selectedOrders[id]
    );

    if (selectedOrderIds.length === 0) {
      console.log("No orders selected.");
      return;
    }

    try {
      // Process all selected orders with Promise.all for parallel processing
      await Promise.all(
        selectedOrderIds.map(async (orderId) => {
          const bookingData = {
            proposedBy: userEmail,
            status: 'new order',
            group: null
          };
          return bookingService.updateBooking(orderId, bookingData);
        })
      );

      alert("Bookings restored successfully.");
      window.location.reload();
    } catch (error) {
      console.error("Error restoring selected orders:", error);
      alert("Failed to restore selected orders. Please try again.");
    }
  };

  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: "16px", margin: "0" }}>
            <svg
              version="1.1"
              id="Isolationsmodus"
              x="0px"
              y="0px"
              viewBox="0 0 322.9 257.78"
              shapeRendering="geometricPrecision"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z"
              />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  function reformatDate(dateStr) {
    // Check for timestamp format (date and time)
    const timestampRegex = /^\d{4}-\d{2}-\d{2}(T| )\d{2}:\d{2}:\d{2}/;
    // Check for 'd.m.yyyy' or 'dd.mm.yyyy' format
    const dateRegex = /^\d{1,2}\.\d{1,2}\.\d{4}$/;

    if (timestampRegex.test(dateStr)) {
      // Extract the date part and convert to 'DD/MM/YYYY' format
      const datePart = dateStr.split(/T| /)[0];
      const [year, month, day] = datePart.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    } else if (dateRegex.test(dateStr)) {
      // Split the date, pad each part with leading zero if necessary, and join with slashes
      return dateStr
        .split(".")
        .map((part) => part.padStart(2, "0"))
        .join("/");
    } else {
      // If the date is not in the expected format, return it as is
      return dateStr;
    }
  }

  function extractAndFormatDate(dateTimeStr) {
    // Use moment.js to parse the date string
    const date = moment(dateTimeStr, "DD/MM/YYYY, HH:mm:ss"); // Adjust the format to match your input

    // Check if the date is valid
    if (date.isValid()) {
      // Format the date to a string, e.g., 'DD/MM/YYYY'
      return date.format("DD/MM/YYYY");
    } else {
      // If the date is invalid, handle accordingly
      return "Invalid Date";
    }
  }

  // Helper function to get creation date display with better error handling
  const getCreatedAtDisplay = (event) => {
    if (!event) return '';
    
    // Check for created_at field first (snake_case)
    if (event.created_at) {
      try {
        const date = new Date(event.created_at);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString();
        }
      } catch (e) {
        console.error('Error parsing created_at date:', e);
      }
    }
    
    // Check for createdAt field (camelCase)
    if (event.createdAt) {
      try {
        // If createdAt is already a string in the format 'DD/MM/YYYY, HH:mm:ss'
        if (typeof event.createdAt === 'string' && event.createdAt.includes('/')) {
          return extractAndFormatDate(event.createdAt);
        } else {
          // If createdAt is a Date object or timestamp
          const date = new Date(event.createdAt);
          if (!isNaN(date.getTime())) {
            return date.toLocaleDateString();
          }
        }
      } catch (e) {
        console.error('Error parsing createdAt date:', e);
      }
    }
    
    return '';
  };

  const createdAtOptions = [...new Set(events.map(event => getCreatedAtDisplay(event)).filter(date => date !== ''))]
    .map(date => ({ value: date, label: date }));

  // Helper functions to extract display values from objects
  const getClientDisplay = (event) => {
    if (!event) return '';
    
    if (event.client) {
      // Handle client as an object with label property
      if (typeof event.client === 'object' && event.client.label) {
        return event.client.label;
      }
      
      // Handle client as a string
      if (typeof event.client === 'string') {
        return event.client;
      }
    }
    
    return '';
  };

  const getPositionDisplay = (event) => {
    if (!event) return '';
    
    if (event.position) {
      // Handle position as an object with label property
      if (typeof event.position === 'object' && event.position.label) {
        return event.position.label;
      }
      
      // Handle position as a string
      if (typeof event.position === 'string') {
        return event.position;
      }
    }
    
    return '';
  };

  const getLocationDisplay = (event) => {
    if (!event) return '';
    
    // Handle location as an object with properties
    if (event.location && typeof event.location === 'object') {
      return event.location.short || event.location.name || event.location.city || '';
    } else if (typeof event.location === 'string') {
      return event.location;
    }
    
    return '';
  };

  const startDate = [...new Set(events.map((event) => event.start))].map(
    (start) => {
      const formattedDate = start instanceof Date ? 
        start.toLocaleDateString() : 
        new Date(start).toLocaleDateString();
      return { value: formattedDate, label: formattedDate };
    }
  );

  const clientOptions = [...new Set(events.map((event) => getClientDisplay(event)).filter(client => client !== ''))].map(
    (client) => ({ value: client, label: client })
  );
  
  const positionOptions = [
    ...new Set(events.map((event) => getPositionDisplay(event)).filter(position => position !== '')),
  ].map((position) => ({ value: position, label: position }));
  
  const setOption = [...new Set(events.map((event) => event.set))].map(
    (set) => ({ value: set, label: set })
  );

  const locationOptions = [
    ...new Set(events.map((event) => {
      return getLocationDisplay(event);
    }).filter(location => location !== '')), // Remove empty strings
  ].map((location) => ({ value: location, label: location }));

  const sortedAndFilteredEvents = events
    .sort((a, b) => {
      const startDateA = new Date(a.start);
      const startDateB = new Date(b.start);
      return startDateB - startDateA; // Descending order by start date
    })
    .filter((event) => {
      const matchesSearchTerm =
        event.boktitle?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.set?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.talent?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.status?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        event.company?.toLowerCase().includes(searchTerm.toLowerCase());

      // Format date for comparison
      const startDateFormatted = event.start instanceof Date ? 
        event.start.toLocaleDateString() : 
        new Date(event.start).toLocaleDateString();
        
      const matchesCreatedAt =
        !selectedCreatedAt || getCreatedAtDisplay(event) === selectedCreatedAt.value;
        
      const matchesstartdAt =
        !selectedstartDate || startDateFormatted === selectedstartDate.value;

      const matchesClient =
        !selectedClient || getClientDisplay(event) === selectedClient.value;
        
      const matchesPosition =
        !selectedPosition || getPositionDisplay(event) === selectedPosition.value;
        
      const matchesSet = 
        !selectedSet || event.set === selectedSet.value;
        
      const matchesLocation = !selectedLocation || getLocationDisplay(event) === selectedLocation.value;

      return (
        matchesSearchTerm &&
        matchesCreatedAt &&
        matchesClient &&
        matchesPosition &&
        matchesstartdAt &&
        matchesSet &&
        matchesLocation
      );
    });

  const processedGroups = new Set();

  return (
    <div>
      <div style={{ marginTop: '40px', marginBottom: '60px' }}>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleChange}
          className='inputtext search'
        />
        
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '10px' }}>
            <Select
              value={selectedClient}
              onChange={setSelectedClient}
              options={clientOptions}
              isClearable
              placeholder="Filter by Client"
              styles={customStyles}
            />
            <Select
              value={selectedstartDate}
              onChange={setSelectedstartDate}
              options={startDate}
              isClearable
              placeholder="Filter by Date"
              components={{ DropdownIndicator }}
              styles={customStyles}
            />
            <Select
              value={selectedCreatedAt}
              onChange={setSelectedCreatedAt}
              options={createdAtOptions}
              isClearable
              placeholder="Filter by Created Date"
              styles={customStyles}
            />
            <Select
              value={selectedPosition}
              onChange={setSelectedPosition}
              options={positionOptions}
              isClearable
              placeholder="Filter by Position"
              styles={customStyles}
            />
            <Select
              value={selectedSet}
              onChange={setSelectedSet}
              options={setOption}
              isClearable
              placeholder="Filter by Set"
              styles={customStyles}
            />
            <Select
              value={selectedLocation}
              onChange={setSelectedLocation}
              options={locationOptions}
              isClearable
              placeholder="Filter by Location"
              styles={customStyles}
            />
          </div>
          
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center', height: '100%' }}>
            <Select
              value={preferenceOptions.find(
                (option) => option.value === selectedPreferenceIndex
              )}
              onChange={handlePreferenceChange}
              options={preferenceOptions}
              isClearable
              placeholder="Select Preference"
              styles={customStyles}
            />
            <button
              className="button"
              style={{ padding: 7 }}
              onClick={() => saveOrUpdateFilterPreference()}
            >
              Save/Update{" "}
            </button>
          </div>
        </div>
        
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
          <button className="button" onClick={markTheOrder} disabled={Object.values(selectedOrders).filter(Boolean).length === 0}>
            Mark the orders
          </button>
          <button className="button-red" onClick={RestoreTheOrder} disabled={Object.values(selectedOrders).filter(Boolean).length === 0}>
            Restore Deleted Order
          </button>
        </div>
      </div>

      <div className="content-wrapper content-wrapper-talent-list">
        <div className="list-tasks-header" style={{ display: "flex" }}>
          <div style={{ flexBasis: "40px" }}></div>
          <div style={{ flexBasis: "150px" }}>groups / Processing by</div>
          <div style={{ flexBasis: "150px" }}>start/end</div>
          <div style={{ flexBasis: "100px" }}>client</div>
          <div style={{ flexBasis: "100px" }}>studio location</div>
          <div style={{ flexBasis: "100px" }}>set</div>
          <div style={{ flexBasis: "80px" }}>kpi</div>
          <div style={{ flexBasis: "150px" }}>position</div>
          <div style={{ flexBasis: "100px" }}>Model</div>
          <div style={{ flexBasis: "150px" }}>Created at</div>
          <div style={{ flexBasis: "150px" }}>Talent</div>
          <div style={{ flexBasis: "150px" }}>S. Info</div>
          <div style={{ flexBasis: "150px" }}></div>
        </div>

        {sortedAndFilteredEvents.map((event) => {
          const formattedDate = getCreatedAtDisplay(event) || "Unknown";
          
          const shouldDisplayIcon = !event.group || !processedGroups.has(event.group);
          if (event.group) {
            processedGroups.add(event.group);
          }
          
          return (
            <div className="list-tasks-item" style={{ display: "flex" }} key={event.id}>
              <div style={{ flexBasis: "40px" }} className="custom-checkbox">
                <input
                  type="checkbox"
                  id={`checkbox-${event.id}`}
                  checked={!!selectedOrders[event.id]}
                  onChange={() => handleCheckboxChange(event.id)}
                />
                <label htmlFor={`checkbox-${event.id}`}></label>
              </div>
              <div style={{ flexBasis: "150px" }}>
                {event.groupColor ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: event.groupColor,
                      color: "#ffffff",
                      padding: "5px 8px",
                      borderRadius: "0",
                      fontSize: "0.8em",
                    }}
                  >
                    {event.group}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#ffffff",
                      padding: "5px 8px",
                      borderRadius: "0",
                      fontSize: "0.8em",
                    }}
                  ></div>
                )}
                / {event.proposedBy}
              </div>
              <div style={{ flexBasis: "150px" }}>
                <div>
                  {new Date(event.start).toLocaleDateString()}
                  <br /> {event.startTime}- {event.endTime}
                </div>
                {event.created_at && (
                  <div style={{ 
                    fontSize: '0.75rem', 
                    color: '#666', 
                    marginTop: '2px',
                    fontStyle: 'italic'
                  }}>
                    Created: {new Date(event.created_at).toLocaleDateString()} {new Date(event.created_at).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                  </div>
                )}
              </div>
              <div style={{ flexBasis: "100px" }}>{getClientDisplay(event)}</div>
              <div style={{ flexBasis: "100px" }}>
                {event.studio}/ {getLocationDisplay(event)}
              </div>
              <div style={{ flexBasis: "100px" }}>{event.set}</div>
              <div style={{ flexBasis: "80px" }}>{event.kpi}</div>
              <div style={{ flexBasis: "150px" }}>{getPositionDisplay(event)}</div>
              <div style={{ flexBasis: "100px" }}>{event.range}</div>
              <div style={{ flexBasis: "150px" }}>{formattedDate}</div>
              <div style={{ flexBasis: "150px" }}>{event.talent}</div>
              <div style={{ flexBasis: "150px" }}>{event.SonstigeInfo}</div>
              <div style={{ flexBasis: "150px" }}>
                <a href={`detail?id=${event.id}`} style={{ color: 'blue', textDecoration: 'underline', paddingRight: 5 }}>
                  <img src={edit} alt="Edit" className="edit-container" />
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DeletedOrdersList;
